module.exports = new __parcel__URL__("GetTheDetailsYouNeedLight.9900190e.gif").toString();